import React from 'react'

export const Credits = () => {
    return <div id="credits">
        <div>
            Pääkaupunkiseudun-Matka-aikamatriisi, jonka tekijä on MetropAccess-hanke / Accessibility Research Group (Helsingin Yliopisto) on lisensoitu Creative Commons Nimeä 4.0 Kansainvälinen -lisenssillä
        </div>
        <div>
            Visualisaation ohjelmistolähdekoodi, jonka tekijä on Max Kalhama on lisensoitu Creative Commons Nimeä 4.0 Kansainvälinen -lisenssillä
        </div>
        <a href="https://github.com/Kalhama/matka-aika">Sivuston lähdekoodi</a>. <a href="https://blogs.helsinki.fi/saavutettavuus/">Metropaccess-hankkeen nettisivut</a>
    </div>
}